import defprotocol from '../defprotocol'
import Function from '../types/Function'

const Extendable = defprotocol({
  extend: Function
})

export default Extendable
